$(document).ready(function(){
    accordion = $('.s-service__accordion');
    if (accordion.length > 0) {

        folds = accordion.find('.c-fold');

        accordion.find('.c-fold').each(function(){
            var fold = $(this);
            var title = fold.find('.c-fold__title');
            var open = fold.find('.c-fold__open');
            var close = fold.find('.c-fold__close');

            open.click(function(){
                folds.removeClass('c-fold--open');
                fold.addClass('c-fold--open');
            });

            close.click(function(){
                fold.removeClass('c-fold--open');
            });

            title.click(function(){
                if (!fold.hasClass('c-fold--open')) {
                    folds.removeClass('c-fold--open');
                }
                fold.toggleClass('c-fold--open');
            });

        });

    }
});